const SYMBOL_PATTERN = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
const DIGIT_PATTERN = /[\d]/
const LOWERCASE_PATTERN = /[a-z]/
const UPPERCASE_PATTERN = /[A-Z]/

export function validate(password: string): string | null {
    if (password.length < 8) {
        return 'password must be at least 8 characters long';
    }

    const symbolFound = SYMBOL_PATTERN.test(password);
    const numberFound = DIGIT_PATTERN.test(password);
    if (!symbolFound && !numberFound) {
        return 'at least 1 symbol or number must be present in password';
    }

    const lowerLetterFound = LOWERCASE_PATTERN.test(password);
    const upperLetterFound = UPPERCASE_PATTERN.test(password);
    if (!lowerLetterFound || !upperLetterFound) {
        return 'must have at least 1 lower and 1 upper letter';
    }

    return null;
}